import { Query } from '@/app/tracking/api';
import { GradingMethod } from './grading-method';
import { ExamResult } from './exam-result'

export interface QueryExamResultsTrackingQueryPayload {
}

export interface QueryExamResultsTrackingQueryResult {
  exams: Exam[]
}

interface Exam {
  id: string
  attempts: Attempt[]
  effectiveGrading: GradingMethod
}

interface Attempt {
  timestamp: Date
  score: {
    min: number,
    raw: number,
    max: number,
  }
  passingScore: number
  result: ExamResult
  durationSeconds: number
}

export const QueryExamResultsTrackingQueryName = 'query-exam-results' as const
export type QueryExamResultsTrackingQuery =
      Query<typeof QueryExamResultsTrackingQueryName, QueryExamResultsTrackingQueryPayload, QueryExamResultsTrackingQueryResult>
